import { Button } from "@au-schein-de/au-ui-library";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useCart } from "./cart.context";
import { CartHeader } from "./cart-header.component";
import { EmptyCartIcon } from "./empty-cart-icon.component";

export function EmptyCart() {
	const { cartDisclosure } = useCart();

	const { t } = useTranslation();
	const navigate = useNavigate();

	const goToProducts = () => {
		navigate("/products");
		cartDisclosure.close();
	};

	return (
		<>
			<div className="md:px-6">
				<CartHeader onCloseButtonClick={cartDisclosure.close} />
			</div>
			<div className="px-4 md:px-6" data-testid="cart-empty">
				<div className="flex flex-col justify-center items-center space-y-4">
					<EmptyCartIcon />
					<p className="text-h5 text-gray-900">{t("cartEmpty?")}</p>

					<p className="text-body text-center text-gray-900">
						{t("hundredsOfProductsInPharmacies")}
					</p>

					<Button variant="secondary" className="w-full" onClick={goToProducts}>
						{t("productsList")}
					</Button>
				</div>
			</div>
		</>
	);
}
